export default __webpack_public_path__ + "static/media/fondo_ecosystem.cc779425.jpg";